import { useQuery } from '@tanstack/react-query'
import { createFileRoute, useNavigate } from '@tanstack/react-router'
import { useListFilter } from '@/components/layout/record-nav-context'
import { orpc } from '@/lib/orpcClient'
import { DocumentEditor } from '@/routes/finance/-DocumentEditor'

export const Route = createFileRoute('/finance/debit-notes/$id/')({
  component: DebitNoteDetailPage,
})

function DebitNoteDetailPage() {
  const navigate = useNavigate()
  const { id } = Route.useParams()
  const { filter } = useListFilter('debitNote')

  const neighborsQ = useQuery(
    orpc.finance.documents.debitNoteNeighbors.queryOptions({
      input: {
        id,
        search: filter.search || undefined,
        sort: filter.sort,
        // Ook de lijstfilters (status, relatie), zodat positie/totaal en
        // vorige/volgende over precies dezelfde rijen lopen als de lijst toonde.
        filters: filter.filters,
      },
    }),
  )

  return (
    <div className="p-6">
      <DocumentEditor
        kind="ap_debit_note"
        documentId={id}
        nav={{
          entityKey: 'debitNote',
          neighbors: neighborsQ.data,
          listRoute: '/finance/debit-notes',
          toDetail: (id) =>
            navigate({
              to: '/finance/debit-notes/$id',
              params: { id },
              search: (prev) => prev,
            }),
        }}
      />
    </div>
  )
}
